<template>
  <div>
    <el-tooltip :content="mode === 'view' ? t.allowEdit : t.denyEdit" >
      <el-switch
         v-if="canEdit"
         class="fa-custom"
         v-model="mode"
         active-value="edit"
         inactive-value="view"
         active-color="#FF4949"
         inactive-text=""
         active-text=""
         @change="$emit('input', mode)" >
      </el-switch>
    </el-tooltip>
    <el-button
       v-if="canEdit"
       type="success"
       icon="el-icon-fa-plus-square"
       @click="addWidget = true" >
      {{ t.addWidget }}
    </el-button>
    <el-button
       v-if="canEdit"
       type="primary"
       icon="el-icon-fa-eye"
       @click="unarchiveBoard" >
      {{ t.unarchiveBoard }}
    </el-button>
    <el-button
       v-if="canEdit"
       type="warning"
       icon="el-icon-fa-eye-slash"
       @click="archiveBoard" >
      {{ t.archiveBoard }}
    </el-button>
    <el-button
       v-if="canDelete"
       type="danger"
       icon="el-icon-fa-trash"
       @click="deleteBoard" >
      {{ t.deleteBoard }}
    </el-button>
    <el-button v-if="canCreate" type="primary" icon="el-icon-fa-clone" @click="cloneBoard()" >
      {{ t.cloneBoard }}
    </el-button>
    <el-button v-if="canCreate" type="primary" icon="el-icon-fa-plus-square" @click="addBoard()" >
      {{ t.addBoard }}
    </el-button>
    <el-button v-if="canEdit" type="warning" icon="el-icon-fa-users" @click="changeGroup" >
      {{ t.changeGroup }}
    </el-button>
    <el-dialog :title="t.addWidget" :visible.sync="addWidget" :modal="false">
      <el-select v-model="widgetType" :placeholder="t.addWidgetPlaceholder" value-key="id" >
        <el-option
           v-for="widget in availableWidgets"
           :key="widget.id"
           :label="widget.label"
           :value="widget" >
        </el-option>
      </el-select>
      <el-button
         type="success"
         icon="el-icon-fa-plus-square"
         @click="addNewWidget()"
         :disabled="widgetType === null" >
        {{ t.addWidgetConfirm }}
      </el-button>
    </el-dialog>
    <el-dialog :title="t.unarchiveBoard" :visible.sync="unarchiveBoardModal" :modal="false">
      <div v-loading="archivedLoading" >
        <el-select
           v-model="toUnarchiveBoard"
           :placeholder="t.unarchiveBoardPlaceholder"
           value-key="id" >
          <el-option v-for="b in archivedBoards" :key="b.id" :label="b.name" :value="b" >
          </el-option>
        </el-select>
        <el-button
           type="success"
           icon="el-icon-fa-eye"
           @click="unarchiveBoardConfirm"
           :disabled="!toUnarchiveBoard" >
          {{ t.unarchiveBoardConfirm }}
        </el-button>
      </div>
    </el-dialog>
    <el-dialog :title="t.changeGroup" :visible.sync="changeGroupModal" :modal="false">
      <div v-loading="changeGroupLoading" >
        <el-select
           v-model="group"
           :clearable="true"
           :placeholder="t.changeGroupPlaceholder"
           value-key="id" >
          <el-option v-for="g in groups" :key="g.id" :label="g.name" :value="g" >
          </el-option>
        </el-select>
        <el-button
           type="success"
           icon="fa-check"
           @click="changeGroupConfirm" >
          {{ t.changeGroupConfirm }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<style scoped>
.fa-custom {
    font: normal normal normal 14px/1 FontAwesome !important;
}
</style>

<script>
  export default {
    props: {
      value: {
        required: true,
        type: String
      },
      board: {
        required: true,
        type: Object
      },
      t: {
        required: true,
        type: Object
      }
    },
    data () {
      return {
        mode: this.value,
        canEdit: false,
        canCreate: false,
        canDelete: false,
        addWidget: false,
        widgetType: null,
        unarchiveBoardModal: false,
        archivedLoading: false,
        archivedBoards: [],
        toUnarchiveBoard: null,
        changeGroupModal: false,
        changeGroupLoading: false,
        groups: [],
        group: null
      }
    },
    computed: {
      availableWidgets () {
        return this.$store.state.widgets
      },
      baseWidgetWidth () {
        return this.$store.getters.getMacarons('baseWidgetWidth')
      },
      baseWidgetHeight () {
        return this.$store.getters.getMacarons('baseWidgetHeight')
      }
    },
    mounted () {
      this.$store.dispatch('isGranted', {
        attribute: 'CREATE_BOARD',
        subject: 'AppBundle\\Entity\\Macarons\\Board'
      }).then(canCreate => {
        this.canCreate = canCreate
      })
      this.$store.dispatch('isGranted', {
        attribute: 'EDIT_BOARD',
        subject: {
          type: 'entity',
          classname: 'AppBundle\\Entity\\Macarons\\Board',
          id: this.board.id
        }
      }).then(canEdit => {
        this.canEdit = canEdit
      }).catch(() => {
        this.canEdit = false
      })
      this.$store.dispatch('isGranted', {
        attribute: 'DELETE_BOARD',
        subject: {
          type: 'entity',
          classname: 'AppBundle\\Entity\\Macarons\\Board',
          id: this.board.id
        }
      }).then(canDelete => {
        this.canDelete = canDelete
      }).catch(() => {
        this.canDelete = false
      })
      this.$watch('board.id', () => {
        this.$store.dispatch('isGranted', {
          attribute: 'EDIT_BOARD',
          subject: {
            type: 'entity',
            classname: 'AppBundle\\Entity\\Macarons\\Board',
            id: this.board.id
          }
        }).then(canEdit => {
          this.canEdit = canEdit
        }).catch(() => {
          this.canEdit = false
        })
        this.$store.dispatch('isGranted', {
          attribute: 'DELETE_BOARD',
          subject: {
            type: 'entity',
            classname: 'AppBundle\\Entity\\Macarons\\Board',
            id: this.board.id
          }
        }).then(canDelete => {
          this.canDelete = canDelete
        }).catch(() => {
          this.canDelete = false
        })
      })
    },
    methods: {
      deleteBoard () {
        this.loading = true
        this.$store.dispatch('deleteBoard').then(() => {
          this.$emit('reload')
        })
      },
      archiveBoard () {
        this.$store.dispatch('archiveBoard').then(() => {
          this.$emit('reload')
        })
      },
      addNewWidget () {
        this.addWidget = false
        this.$emit('newWidget', {
          x: 0,
          y: 0,
          w: typeof this.widgetType.w === 'undefined' ? this.baseWidgetWidth : this.widgetType.w,
          h: typeof this.widgetType.h === 'undefined' ? this.baseWidgetHeight : this.widgetType.h,
          widget: this.widgetType.component,
          options: typeof this.widgetType.options === 'object' ? this.widgetType.options : {},
          id: this.widgetType.id
        })
      },
      unarchiveBoard () {
        this.archivedLoading = true
        this.unarchiveBoardModal = true
        this.$store.dispatch('archivedBoards').then(response => {
          this.archivedBoards.splice(0, this.archivedBoards.length, ...response.data.boards)
          this.archivedLoading = false
        })
      },
      unarchiveBoardConfirm () {
        this.$store.dispatch('unarchiveBoard', this.toUnarchiveBoard).then(() => {
          this.unarchiveBoardModal = false
          this.$emit('reload')
        })
      },
      addBoard () {
        this.$store.dispatch('addBoard').then(() => {
          this.$emit('reload')
        })        
      },
      changeGroup () {
        this.changeGroupLoading = true
        this.changeGroupModal = true
        this.$store.dispatch('listGroup').then(({data}) => {
          this.groups.splice(0, this.groups.length, ...data)
          this.changeGroupLoading = false
        })
      },
      changeGroupConfirm () {
        this.changeGroupModal = false
        this.$store.dispatch('updateBoard', {
          group: this.group ? this.group.id : null
        })
      },
      cloneBoard () {
        this.$store.dispatch('cloneBoard').then(() => {
          this.$emit('reload')
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// node_modules/macarons/src/components/PortalToolbox.vue